<ng-container *ngIf="!loading">
  <ng-container *ngIf="viewMode === ViewMode.List">
    <!-- Card Builder Button (only for Card mode) -->
    <div *ngIf="cardBuilderButton && listMode === ListMode.Card" class="card-builder-button-container">
      <button nz-button
              [nzType]="(cardBuilderButtonConfig?.type === ButtonType.Primary) ? 'primary' : 'default'"
              (click)="openCardBuilder()"
              nz-tooltip
              [nzTooltipTitle]="cardBuilderButtonConfig?.tooltipText || 'Configure Card Settings'">
        <i [ngClass]="cardBuilderButtonConfig?.icon?.name || 'fa-regular fa-gear'"
           [class.white-icon]="cardBuilderButtonConfig?.type === ButtonType.Primary"></i>
        <span>{{ cardBuilderButtonConfig?.text || 'Configure Card' }}</span>
      </button>
    </div>
    <!-- Title Toolbar for List View -->
    <rappider-title-toolbar [mainTitle]="mainTitleConfig"
                            [mainTitleButton]="mainTitleButtonConfig"
                            [displayToolbar]="displayToolbar"
                            [displayToolbarBackButton]="false"
                            [toolbarButtons]="toolbarButtons"
                            [displayBreadcrumb]="displayBreadCrumb"
                            [displayGripButton]="displayGripButton"
                            [options]="breadCrumbOptions"
                            [titleBarActionButtons]="listViewTitleBarActionButtons?.length ? listViewTitleBarActionButtons : titleBarActionButtons"
                            [titleBarActionMenu]="titleBarActionMenu"
                            [titleBarSwitchSettings]="titleBarSwitchSettings"
                            [titleBarRadioButtonSettings]="titleBarRadioButtonSettings"
                            (titleBarRadioButtonClick)="onTitleBarRadioButtonClick($event)"
                            (titleBarActionButtonClick)="onTitleBarActionButtonClick($event)"
                            (titleBarActionButtonConfirm)="onTitleBarActionButtonConfirm($event)"
                            (doneClick)="onJoyrideDoneButtonClick()"
                            (breadCrumbOptionClick)="onBreadCrumbOptionClicked($event)"
                            (backButtonClick)="onBackButtonClick($event)"
                            (toolbarActionButtonClick)="onToolbarActionButtonClick($event)"
                            (gripButtonClick)="onGripButtonClicked($event)">
    </rappider-title-toolbar>
    <!-- GRID mode -->
    <ng-container *ngIf="listMode === ListMode.Grid">
      <section class="grid-list-container">
        <rappider-list-grid [config]="listGridConfig"
                            [data]="listGridData"
                            [loading]="isListGridDataLoading"
                            [borderless]="isListGridBorderless"
                            [redirectUrlData]="redirectUrlData"
                            [enableRowPointer]="true"
                            (selectionChange)="onSelectionChange($event)"
                            (listActionDropdownItemClick)="onListGridListActionDropdownItemClick($event)"
                            (columnActionClick)="onListGridColumnActionClick($event)"
                            (linkCellClicked)="onLinkCellClicked($event)"
                            (listActionClick)="onListActionClick($event)"
                            (rowActionClick)="onCardViewItemSelected($event)"
                            (listGridVisibilityColumnsChange)="onListGridVisibilityColumnsChanged($event)"></rappider-list-grid>
      </section>
    </ng-container>

    <!-- CARD mode -->
    <ng-container *ngIf="listMode === ListMode.Card">
      <div class="card-list-container">

        <!-- Data loading -->
        <div *ngIf="isListGridDataLoading"
             class="loading">
          <i class="fa fa-spinner fa-spin"></i>
          <span> {{loadingMessage}}</span>
        </div>

        <!-- Search for cards -->
        <div class="search-container">
          <rappider-input-group [(ngModel)]="cardListSearchText"
                                [textbox]="cardSearchInputConfig.textbox"
                                [suffixIcon]="cardSearchInputConfig.suffixIcon"
                                (valueChange)="onSearchInputChange()"></rappider-input-group>
        </div>

        <nz-empty *ngIf="!isListGridDataLoading && (!filteredData || !filteredData?.length)"
                  nzNotFoundImage="simple"
                  class="no-data"></nz-empty>
        <ng-container *ngIf="joyride?.joyrideStep">
          <div *ngFor="let item of filteredData; let i = index; let isLast = last"
               class="item-container rounded-card col-lg-3 col-md-6 col-sm-12 col-xs-12">
            <div [joyrideStep]="joyride?.joyrideStep"
                          [title]="joyride?.title"
                          [text]="joyride?.text"
                          (next)="onCardViewItemSelected(item)"
                          (done)="onJoyrideDoneButtonClick()">
              <rappider-card-ccs *ngIf="isLast"
                                 [colorBand]="item?.color"
                                 [title]="{content: item[cardListConfig?.titleFieldName] || item.title || item.name, type:'h5'}"
                                 [iconConfig]="getCardIconConfig(item)"
                                 [iconName]="!getCardIconConfig(item) ? (item.iconName || '') : undefined"
                                 [subtitles]="getCardSubtitles(item) ?? cardSubtitles[item?.id] || []"
                                 [description]="getCardDescription(item)"
                                 [secondActionButton]="getCardEditButton(item)"
                                 [thirdActionButton]="getCardDeleteButton(item)"
                                 [selected]="item.selected"
                                 [selectedCardIcon]="item.selectedCardIcon"
                                 (actionClick)="onCardViewActionClick($event, item)"
                                 (itemSelect)="onCardViewItemSelected(item)"
                                 (renderCompleted)="onCardCcsRenderCompleted($event)">
              </rappider-card-ccs>
            </div>
            <rappider-card-ccs *ngIf="!isLast"
                               [colorBand]="item?.color"
                               [title]="{content: item[cardListConfig?.titleFieldName] || item.title || item.name, type:'h5'}"
                               [iconConfig]="getCardIconConfig(item)"
                               [iconName]="!getCardIconConfig(item) ? (item.iconName || '') : undefined"
                               [subtitles]="getCardSubtitles(item) ?? cardSubtitles[item?.id] || []"
                               [description]="getCardDescription(item)"
                               [secondActionButton]="getCardEditButton(item)"
                               [thirdActionButton]="getCardDeleteButton(item)"
                               [selected]="item.selected"
                               [selectedCardIcon]="item.selectedCardIcon"
                               (actionClick)="onCardViewActionClick($event, item)"
                               (itemSelect)="onCardViewItemSelected(item)">
            </rappider-card-ccs>
          </div>
        </ng-container>
        <ng-container *ngIf="!joyride?.joyrideStep">
          <div *ngFor="let item of filteredData; let i = index"
               class="item-container rounded-card col-lg-3 col-md-6 col-sm-12 col-xs-12">
            <rappider-card-ccs [colorBand]="item?.color"
                               [title]="{content: item[cardListConfig?.titleFieldName] || item.title || item.name, type:'h5'}"
                               [iconConfig]="getCardIconConfig(item)"
                               [iconName]="!getCardIconConfig(item) ? (item.iconName || '') : undefined"
                               [subtitles]="getCardSubtitles(item) ?? cardSubtitles[item?.id] || []"
                               [description]="getCardDescription(item)"
                               [secondActionButton]="getCardEditButton(item)"
                               [thirdActionButton]="getCardDeleteButton(item)"
                               [selected]="item.selected"
                               [selectedCardIcon]="item.selectedCardIcon"
                               (actionClick)="onCardViewActionClick($event, item)"
                               (itemSelect)="onCardViewItemSelected(item)">
            </rappider-card-ccs>

          </div>
        </ng-container>
      </div>

    </ng-container>

  </ng-container>

  <section *ngIf="viewMode === ViewMode.Create">
    <!-- Form Builder Button for Create View -->
    <div *ngIf="showFormBuilderButton" class="form-builder-button-container">
      <button
        nz-button
        nzType="primary"
        (click)="openCreateFormBuilder()"
        nz-tooltip
        nzTooltipTitle="Configure Create Form Layout and Fields">
        <i class="fa-regular fa-gear"></i> Configure Create Form
      </button>
    </div>

    <!-- Title Toolbar for Create View -->
    <rappider-title-toolbar [mainTitle]="mainTitleConfig"
                            [mainTitleButton]="mainTitleButtonConfig"
                            [displayToolbar]="displayToolbar"
                            [displayToolbarBackButton]="displayToolbarBackButton"
                            [toolbarButtons]="toolbarButtons"
                            [displayBreadcrumb]="displayBreadCrumb"
                            [displayGripButton]="displayGripButton"
                            [options]="breadCrumbOptions"
                            [titleBarActionButtons]="[]"
                            [titleBarActionMenu]="titleBarActionMenu"
                            [titleBarSwitchSettings]="titleBarSwitchSettings"
                            [titleBarRadioButtonSettings]="titleBarRadioButtonSettings"
                            (titleBarRadioButtonClick)="onTitleBarRadioButtonClick($event)"
                            (titleBarActionButtonClick)="onTitleBarActionButtonClick($event)"
                            (titleBarActionButtonConfirm)="onTitleBarActionButtonConfirm($event)"
                            (doneClick)="onJoyrideDoneButtonClick()"
                            (breadCrumbOptionClick)="onBreadCrumbOptionClicked($event)"
                            (backButtonClick)="onBackButtonClick($event)"
                            (toolbarActionButtonClick)="onToolbarActionButtonClick($event)"
                            (gripButtonClick)="onGripButtonClicked($event)">
    </rappider-title-toolbar>
    <rappider-crud-view-edit-form [config]="createFormConfig"
                                  [data]="createFormDefaultData"
                                  [submitButtonLoading]="createFormSubmitButtonLoading"
                                  [dynamicDataForSelectBox]="createFormSubmitButtonLoading"
                                  (formValueChange)="onCreateFormValueChange($event)"
                                  (formSubmit)="onCreateFormSubmit($event)">
    </rappider-crud-view-edit-form>
  </section>

  <section *ngIf="viewMode === ViewMode.Update || viewMode === ViewMode.Edit">
    <!-- Form Builder Button for Edit/Update View -->
    <div *ngIf="showFormBuilderButton" class="form-builder-button-container">
      <button
        nz-button
        nzType="primary"
        (click)="openUpdateFormBuilder()"
        nz-tooltip
        nzTooltipTitle="Configure Edit Form Layout and Fields">
        <i class="fa-regular fa-gear"></i> Configure Edit Form
      </button>
    </div>

    <!-- Title Toolbar for Update/Edit View -->
    <rappider-title-toolbar [mainTitle]="mainTitleConfig"
                            [mainTitleButton]="mainTitleButtonConfig"
                            [displayToolbar]="displayToolbar"
                            [displayToolbarBackButton]="displayToolbarBackButton"
                            [toolbarButtons]="toolbarButtons"
                            [displayBreadcrumb]="displayBreadCrumb"
                            [displayGripButton]="displayGripButton"
                            [options]="breadCrumbOptions"
                            [titleBarActionButtons]="[]"
                            [titleBarActionMenu]="titleBarActionMenu"
                            [titleBarSwitchSettings]="titleBarSwitchSettings"
                            [titleBarRadioButtonSettings]="titleBarRadioButtonSettings"
                            (titleBarRadioButtonClick)="onTitleBarRadioButtonClick($event)"
                            (titleBarActionButtonClick)="onTitleBarActionButtonClick($event)"
                            (titleBarActionButtonConfirm)="onTitleBarActionButtonConfirm($event)"
                            (doneClick)="onJoyrideDoneButtonClick()"
                            (breadCrumbOptionClick)="onBreadCrumbOptionClicked($event)"
                            (backButtonClick)="onBackButtonClick($event)"
                            (toolbarActionButtonClick)="onToolbarActionButtonClick($event)"
                            (gripButtonClick)="onGripButtonClicked($event)">
    </rappider-title-toolbar>
    <rappider-crud-view-edit-form [config]="updateFormConfig"
                                  [data]="updateFormData"
                                  [submitButtonLoading]="updateFormSubmitButtonLoading"
                                  [dynamicDataForSelectBox]="updateFormDynamicDataForSelectBox"
                                  (formValueChange)="onUpdateFormValueChange($event)"
                                  (formSubmit)="onUpdateFormSubmit($event)">
    </rappider-crud-view-edit-form>
  </section>

  <ng-container *ngIf="viewMode === ViewMode.Detail">
    <!-- Item Data Builder Button (only for Detail mode) -->
    <div *ngIf="itemDataBuilderButton && viewMode === ViewMode.Detail" class="data-detail-view-builder-button-container">
      <button nz-button
              [nzType]="(itemDataBuilderButtonConfig?.type === ButtonType.Primary) ? 'primary' : 'default'"
              (click)="openItemDataBuilder()"
              nz-tooltip
              [nzTooltipTitle]="itemDataBuilderButtonConfig?.tooltipText || 'Configure Item Data View Settings'">
        <i [ngClass]="itemDataBuilderButtonConfig?.icon?.name || 'fa-regular fa-gear'"
           [class.white-icon]="itemDataBuilderButtonConfig?.type === ButtonType.Primary"></i>
        <span>{{ itemDataBuilderButtonConfig?.text || 'Configure Item Data View' }}</span>
      </button>
    </div>
    <!-- Title Toolbar for Detail View -->
    <rappider-title-toolbar [mainTitle]="mainTitleConfig"
                            [mainTitleButton]="mainTitleButtonConfig"
                            [displayToolbar]="displayToolbar"
                            [displayToolbarBackButton]="displayToolbarBackButton"
                            [toolbarButtons]="detailViewToolbarButtons"
                            [displayBreadcrumb]="displayBreadCrumb"
                            [displayGripButton]="displayGripButton"
                            [options]="breadCrumbOptions"
                            [titleBarActionButtons]="detailViewTitleBarActionButtons?.length ? detailViewTitleBarActionButtons : titleBarActionButtons"
                            [titleBarActionMenu]="titleBarActionMenu"
                            [titleBarSwitchSettings]="titleBarSwitchSettings"
                            [titleBarRadioButtonSettings]="titleBarRadioButtonSettings"
                            (titleBarRadioButtonClick)="onTitleBarRadioButtonClick($event)"
                            (titleBarActionButtonClick)="onTitleBarActionButtonClick($event)"
                            (titleBarActionButtonConfirm)="onTitleBarActionButtonConfirm($event)"
                            (doneClick)="onJoyrideDoneButtonClick()"
                            (breadCrumbOptionClick)="onBreadCrumbOptionClicked($event)"
                            (backButtonClick)="onBackButtonClick($event)"
                            (toolbarActionButtonClick)="onToolbarActionButtonClick($event)"
                            (gripButtonClick)="onGripButtonClicked($event)">
    </rappider-title-toolbar>
    <ng-container *ngTemplateOutlet="customTemplate"></ng-container>
    <div class="alert-wrapper">
      <rappider-alert *ngIf="getCardAlertConfig(activeItem)"
                      [type]="getCardAlertConfig(activeItem)?.type"
                      [title]="getCardAlertConfig(activeItem)?.title"
                      [description]="getCardAlertConfig(activeItem)?.description"
                      [showIcon]="getCardAlertConfig(activeItem)?.showIcon"></rappider-alert>
    </div>
    <section>
      <rappider-crud-fields-display [data]="activeItem"
                                    [config]="detailViewConfig"
                                    [columnNumber]="crudFieldsDisplayColumnNumber"
                                    (formSubmit)="onUpdateFormValueChange($event)"></rappider-crud-fields-display>
    </section>
    <section *ngIf="activeEntityConfig?.config?.relationsConfig && activeEntityConfig?.config?.relationsConfig.length">
      <div class="related-entities-container">
        <!-- <pre>
        {{activeEntityConfig | json}}
      </pre> -->
        <!-- <h5>Related Entities</h5> -->
        <nz-tabset>
          <ng-container *ngFor="let relatedEntity of activeEntityConfig?.config?.relationsConfig">

            <nz-tab [nzTitle]="relatedEntity?.targetModel?.name || 'Entity'">
              <rappider-crud-view *ngIf="relatedEntity?.targetModel?.name"
                                  [activeEntityConfig]="entityConfigs[relatedEntity?.targetModel?.name!] ?? null"
                                  [entityConfigs]="entityConfigs"
                                  [entityData]="entityData"
                                  [modelNameSingular]="relatedEntity?.targetModel?.name!"
                                  [viewMode]="ViewMode.List"
                                  [listMode]="ListMode.Grid"
                                  [showCreateButton]="true"
                                  [createButtonTitle]="entityConfigs[relatedEntity?.targetModel?.name!]?.createItemTitle ?? 'Add New' "
                                  [displayToolbar]="true"
                                  [displayToolbarBackButton]="true"
                                  [titleBarActionButtons]="titleBarActionButtons"
                                  [titleBarActionMenu]="titleBarActionMenu"
                                  [listGridData]="entityData && entityConfigs[relatedEntity?.targetModel?.name!]?.config?.entityDataListSelector ? entityData[entityConfigs[relatedEntity?.targetModel?.name!]?.config?.entityDataListSelector] : []"
                                  [activeItemId]="activeItemId"
                                  [listGridConfig]="entityConfigs[relatedEntity?.targetModel?.name!]?.config?.listGridConfig!"
                                  [cardListConfig]="entityConfigs[relatedEntity?.targetModel?.name!]?.config?.cardListConfig!"
                                  [createFormConfig]="entityConfigs[relatedEntity?.targetModel?.name!]?.config?.createItemFormConfig!"
                                  [updateFormConfig]="entityConfigs[relatedEntity?.targetModel?.name!]?.config?.updateItemFormConfig!"
                                  [detailViewConfig]="entityConfigs[relatedEntity?.targetModel?.name!]?.config?.detailViewConfig!"
                                  (createFormSubmit)="onCreateFormSubmit($event)"
                                  (updateFormSubmit)="onUpdateFormSubmit($event)"
                                  (itemDeleted)="onRelatedItemDeleted($event)"
                                  (titleBarActionButtonClicked)="onRelatedItemTitleBarActionButtonClicked($event)"
                                  (titleBarActionButtonConfirm)="onTitleBarActionButtonConfirm($event)"></rappider-crud-view>

              <!-- <hr>
            entityConfigs[relatedEntity?.targetModel?.name!]
            <br>
            <pre>{{entityConfigs[relatedEntity?.targetModel?.name!] | json}}</pre>

            <hr>
            relatedEntity
            <br>
            <pre> {{relatedEntity | json}}</pre>

            <hr>
            listGridData
            <br>
            <pre> {{listGridData | json}}</pre>

            <hr>
            entityData
            <br>
            <pre> {{entityData | json}}</pre> -->


            </nz-tab>
          </ng-container>
        </nz-tabset>
      </div>
    </section>
  </ng-container>

</ng-container>

<!-- Grid Builder Component -->
<rappider-grid-builder #gridBuilder
                       *ngIf="gridBuilderButton"
                       [ngModel]="gridBuilderConfig"
                       (blur)="onGridBuilderConfigSave($event)"
                       [style.display]="'none'">
</rappider-grid-builder>

<!-- Card Builder Component -->
<rappider-card-builder #cardBuilder
                       *ngIf="cardBuilderButton"
                       [ngModel]="cardBuilderConfig"
                       (blur)="onCardBuilderConfigSave($event)"
                       [style.display]="'none'">
</rappider-card-builder>

<!-- Item Data Builder Component -->
<rappider-data-detail-view-builder #itemDataBuilder
                             *ngIf="itemDataBuilderButton"
                             [ngModel]="itemDataBuilderConfig"
                             (configChange)="onItemDataBuilderConfigSave($event)"
                             [style.display]="'none'">
</rappider-data-detail-view-builder>

<!-- Form Builder Components -->
<rappider-form-builder #createFormBuilder
                       *ngIf="showFormBuilderButton"
                       [ngModel]="formBuilderConfig.create"
                       (blur)="onFormBuilderConfigSave('create', $event)"
                       [style.display]="'none'">
</rappider-form-builder>

<rappider-form-builder #updateFormBuilder
                       *ngIf="showFormBuilderButton"
                       [ngModel]="formBuilderConfig.update"
                       (blur)="onFormBuilderConfigSave('update', $event)"
                       [style.display]="'none'">
</rappider-form-builder>
